import { BaseModel } from '@/api/base-model'
import { PipelineConnectionAPI } from '@/api/backend-client'
import { Pipeline } from '@/api/model/pipeline'
import { Company } from '@/api/model/company'

export class PipelineConnection extends BaseModel<PipelineConnection> {
    protected collectionName = PipelineConnectionAPI.collectionName

    constructor(
        public id: string,
        public pipeline: Pipeline|null,
        public excludedFields: string[],
        public sourceCompany: Company,
        public sourceEnabled: boolean,
        public targetCompany: Company,
        public targetEnabled: boolean,
    ) { super(id) }

    get isActive(): boolean {
        return this.sourceEnabled && this.targetEnabled && this.pipeline !== null
    }

    get isInterrupted(): boolean {
        return this.sourceEnabled === false
            || this.targetEnabled === false
            || this.pipeline === null
    }

    get isInterruptedRemotely(): boolean {
        return this.sourceEnabled === true && this.targetEnabled === false
    }

    get isInterruptedLocally(): boolean {
        return this.sourceEnabled === false && this.targetEnabled === true
    }

    static fromData(data: any): PipelineConnection {
        if (data === null || typeof data === 'string' || data instanceof PipelineConnection) {
            return data
        }

        return new PipelineConnection(
            data.id,
            data.pipeline ? Pipeline.fromData(data.pipeline) : null,
            data.excludedFields,
            data.sourceCompany ? Company.fromData(data.sourceCompany) : null,
            data.sourceEnabled,
            data.targetCompany ? Company.fromData(data.targetCompany) : null,
            data.targetEnabled,
        )
    }
}
